import { defineMessages } from 'react-intl';

export const configurationApiMessages = defineMessages({
	configurations__label: {
		id: 'configuration.api.configurations.label',
		defaultMessage:
			'{count, plural, one {Configuration} other {Configurations}}',
	},
});
